'use strict';

const react = require('@emotion/react');
const components_display_Badge_Badge = require('../../display/Badge/Badge.cjs.js');

const badgeOverrides = react.css({
  "& > span": {
    minWidth: "26px !important"
  }
});
function PageNavigationBadge(props) {
  return react.jsx(
    "span",
    { css: badgeOverrides, "data-zds": true },
    react.jsx(components_display_Badge_Badge.Badge, Object.assign({}, props))
  );
}

module.exports = PageNavigationBadge;
//# sourceMappingURL=PageNavigationBadge.cjs.js.map
